import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import dateFormat from 'dateformat'

import Layout from '../components/Layout'
import Tags from '../components/Tags'
import SiblingPosts from '../components/SiblingPosts'
import Markdown from '../components/Markdown'

import MetaTags from '../components/MetaTags'

const Section = styled.section`
  max-width: 960px;
  margin: 5vw auto;
  padding: 20px;
`

const Header = styled.section`
  width: 100%;
  height: 100vh;

  background-size: cover;
  background-blend-mode: multiply;
  background-color: #00000061 !important;
  background-image: ${(props) => props.imgSrc};

  @media screen and (max-width: 768px) {
    height: initial;
  }
`

export default class BlogPost extends Component {
  componentDidMount () {
    // console.log(this.props)
  }
  render () {
    const {
      title,
      tags,
      content: { content },
      createdAt,
      headerImage,
      titleSlug,
      contentBrief,
      next,
      previous
    } = this.props.pageContext
    const date = dateFormat(new Date(createdAt), 'dddd, mmmm dS, yyyy, h:MM TT')

    // short description of the content (with some fallbacks)
    const contentDescription = contentBrief || content.replace(/[^a-zA-Z0-9 .!?]/g, '').substring(0, 100) || ''

    return (
      <React.Fragment>
        <Layout withContrast>
          <article>
            <Header className='hero is-dark' imgSrc={`url(${headerImage.fullsize.src}&fm=jpg&fl=progressive)`}>
              <div className='level blog-heading'>
                <div>
                  <h1 className='title is-1'>{title}</h1>
                  <h2 className='subtitle is-3'>
                    <time dateTime={createdAt}>Posted on {date}</time>
                  </h2>
                  <Tags tags={tags} />
                </div>
              </div>
            </Header>
            <Section className='content'>
              <Markdown source={content} />
            </Section>
          </article>
          <SiblingPosts posts={{ next, previous }} />
        </Layout>
        <MetaTags
          type='article'
          title={title}
          url={`johannesekman.com/blog/${titleSlug}`}
          image={`https:${headerImage.thumbnail.src}`}
          description={contentDescription}
        />
        <Helmet>
          <meta property='article:published_time' content={createdAt} />
        </Helmet>
      </React.Fragment>
    )
  }
}
